export default __webpack_public_path__ + "assets/svg/Kettlebell.bef12070111d2a1d93f69bb6f1619e38.svg";